import React from 'react';
import { useLocation } from "react-router-dom";
import { connect } from 'react-redux';
import clsx from 'clsx';

import { setSidebarToggleMobile } from '../../reducers/ThemeOptions';
import HeaderUserbox from '../HeaderUserbox';
import HeaderSearch from '../../layout-components/HeaderSearch';
import { WEB_CONTENT_PATH } from 'Constants';

const Header = (props) => {
  const {
    headerShadow,
    headerBgTransparent,
    sidebarToggleMobile,
    setSidebarToggleMobile
  } = props;

  const { pathname } = useLocation()

  const toggleSidebarMobile = () => {
    setSidebarToggleMobile(!sidebarToggleMobile);
  };

  const showSearchBar = !pathname.includes(WEB_CONTENT_PATH);

  return (
    <>
      <div
        className={clsx('app-header', {
          'app-header--shadow': headerShadow,
          'app-header--opacity-bg': headerBgTransparent
        })}>
        <div
          style={{
            width: '100%'
          }}
          className="app-header--pane w100">
          <button
            className={clsx(
              'navbar-toggler hamburger hamburger--elastic toggle-mobile-sidebar-btn',
              { 'is-active': sidebarToggleMobile }
            )}
            onClick={toggleSidebarMobile}>
            <span className="hamburger-box">
              <span className="hamburger-inner" />
            </span>
          </button>
          {showSearchBar &&  <HeaderSearch />}
          <div
            style={{
              marginLeft: 'auto'
            }}
            className="text-center d-flex">
            <HeaderUserbox />
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  headerShadow: state.ThemeOptions.headerShadow,
  headerBgTransparent: state.ThemeOptions.headerBgTransparent,
  sidebarToggleMobile: state.ThemeOptions.sidebarToggleMobile
});

const mapDispatchToProps = (dispatch) => ({
  setSidebarToggleMobile: (enable) => dispatch(setSidebarToggleMobile(enable))
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
